import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import {
  routes
} from './routes';

import VeeValidate, {
  Validator
} from 'vee-validate';
import pt_BR from 'vee-validate/dist/locale/pt_BR';

import FlashMessage from '@smartweb/vue-flash-message';

import 'font-awesome/css/font-awesome.min.css';
import 'hover.css';

import 'jquery/dist/jquery.slim';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

import Paginate from 'vuejs-paginate';

import NProgress from 'nprogress';

import './assets/css/style.scss';
import './assets/css/nprogress.css';

Vue.use(FlashMessage);
Vue.component('paginate', Paginate);

Vue.use(VueResource);
Vue.http.options.root = process.env.API_URL ? process.env.API_URL : 'http://127.0.0.1:8000/api/';

Vue.http.interceptors.push((req, next) => {
  NProgress.start();

  if (localStorage.getItem('access_token')) {
    req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  }

  next(res => {

    if (parseInt(res.status, 10) == 401) {
      router.push({
        name: 'login'
      })
    }

    NProgress.done();

  });

});

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history'
});

Vue.use(VeeValidate);
Validator.localize('./locale/pt_BR', pt_BR);

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js